import { ID, UploadFlowWarningColors, UploadFlowWarnings } from "@nova/constants"
import { set } from "nodash"
import {
    getNoLocationIds,
    getThermalDataIds,
} from "panels/content/side-panel/upload-flow/GenericWarningProcessors"
import { ColorFinderState } from "./ImageColorFinderSlice"

export const ImageColorfinderUploadFlowWarnings: Record<
    ID,
    Record<UploadFlowWarnings, { ids: ID[]; color: string }>
> = {}

const addWarning = (
    flightId: string,
    imageColors: Record<ID, string>,
    warning: UploadFlowWarnings,
    ids: ID[]
) => {
    set(ImageColorfinderUploadFlowWarnings, flightId + "." + warning, {
        ids,
        color: UploadFlowWarningColors[warning],
    })

    return {
        ...imageColors,
        ...Object.fromEntries(ids.map((id) => [id, UploadFlowWarningColors[warning]])),
    }
}

export const imageColorfinderWarningProcessor = (flightId: string, uploads: ColorFinderState[]) => {
    let imageColors: Record<ID, string> = {}

    //Warnings
    const thermalDataIds = getThermalDataIds(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.IR, thermalDataIds)

    //Errors
    const noLocationIds = getNoLocationIds(uploads)
    imageColors = addWarning(flightId, imageColors, UploadFlowWarnings.NoLocation, noLocationIds)

    return imageColors
}
